import Cookies from 'js-cookie';

function SettingsController($scope, $translate, $rootScope, $timeout, $http, User, ResetPasswordValidationSvc, ContactInfoSvc, ResetPasswordSvc, MemberSvc, EmailSettingsSvc, AnonWinnerSettingsSvc) {
  'ngInject';
  $scope.UserHistory = {}
  $scope.isWinHistory = false;
  $scope.User = User;
  $scope.isRobot = false;
  $scope.States = []

  $scope.Countries = [
	  {
		  ISOCode: "CA", Name: "Canada", States: [
			  { Name: "New Brunswick", ISOCode: "NB" },
			  { Name: "Nova Scotia", ISOCode: "NS" },
			  { Name: "Prince Edwards Island", ISOCode: "PE" },
			  { Name: "Newfoundland", ISOCode: "NL" },
			  { Name: "Quebec", ISOCode: "QC" },
			  { Name: "Ontario", ISOCode: "ON" },
			  { Name: "Saskatchewan", ISOCode: "SK" },
			  { Name: "Manitoba", ISOCode: "MB" },
			  { Name: "Alberta", ISOCode: "AB" },
			  { Name: "British Columbia", ISOCode: "BC" },
			  { Name: "NorthWest Territories", ISOCode: "NT" },
			  { Name: "Yukon", ISOCode: "YT" },
			  { Name: "Nunavut", ISOCode: "NU" }
		  ]
	  },
	  {
		  ISOCode: "US", Name: "United States of America", States: [
			  { Name: "Alabama", ISOCode: "AL" },
			  { Name: "Alaska", ISOCode: "AK" },
			  { Name: "American Samoa", ISOCode: "AS" },
			  { Name: "Arizona", ISOCode: "AZ" },
			  { Name: "Arkansas", ISOCode: "AR" },
			  { Name: "California", ISOCode: "CA" },
			  { Name: "Colorado", ISOCode: "CO" },
			  { Name: "Connecticut", ISOCode: "CT" },
			  { Name: "Delaware", ISOCode: "DE" },
			  { Name: "District of Columbia", ISOCode: "DC" },
			  { Name: "Federated States of Micronesia", ISOCode: "FM" },
			  { Name: "Florida", ISOCode: "FL" },
			  { Name: "Georgia", ISOCode: "GA" },
			  { Name: "Guam", ISOCode: "GU" },
			  { Name: "Hawaii", ISOCode: "HI" },
			  { Name: "Idaho", ISOCode: "ID" },
			  { Name: "Illinois", ISOCode: "IL" },
			  { Name: "Indiana", ISOCode: "IN" },
			  { Name: "Iowa", ISOCode: "IA" },
			  { Name: "Kansas", ISOCode: "KS" },
			  { Name: "Kentucky", ISOCode: "KY" },
			  { Name: "Louisiana", ISOCode: "LA" },
			  { Name: "Maine", ISOCode: "ME" },
			  { Name: "Marshall Islands", ISOCode: "MH" },
			  { Name: "Maryland", ISOCode: "MD" },
			  { Name: "Massachusetts", ISOCode: "MA" },
			  { Name: "Michigan", ISOCode: "MI" },
			  { Name: "Minnesota", ISOCode: "MN" },
			  { Name: "Mississippi", ISOCode: "MS" },
			  { Name: "Missouri", ISOCode: "MO" },
			  { Name: "Montana", ISOCode: "MT" },
			  { Name: "Nebraska", ISOCode: "NE" },
			  { Name: "Nevada", ISOCode: "NV" },
			  { Name: "New Hampshire", ISOCode: "NH" },
			  { Name: "New Jersey", ISOCode: "NJ" },
			  { Name: "New Mexico", ISOCode: "NM" },
			  { Name: "New York", ISOCode: "NY" },
			  { Name: "North Carolina", ISOCode: "NC" },
			  { Name: "North Dakota", ISOCode: "ND" },
			  { Name: "Northern Mariana Islands", ISOCode: "MP" },
			  { Name: "Ohio", ISOCode: "OH" },
			  { Name: "Oklahoma", ISOCode: "OK" },
			  { Name: "Oregon", ISOCode: "OR" },
			  { Name: "Palau", ISOCode: "PW" },
			  { Name: "Pennsylvania", ISOCode: "PA" },
			  { Name: "Puerto Rico", ISOCode: "PR" },
			  { Name: "Rhode Island", ISOCode: "RI" },
			  { Name: "South Carolina", ISOCode: "SC" },
			  { Name: "South Dakota", ISOCode: "SD" },
			  { Name: "Tennessee", ISOCode: "TN" },
			  { Name: "Texas", ISOCode: "TX" },
			  { Name: "Utah", ISOCode: "UT" },
			  { Name: "Vermont", ISOCode: "VT" },
			  { Name: "Virgin Island", ISOCode: "VI" },
			  { Name: "Virginia", ISOCode: "VA" },
			  { Name: "Washington", ISOCode: "WA" },
			  { Name: "West Virginia", ISOCode: "WV" },
			  { Name: "Wisconsin", ISOCode: "WI" },
			  { Name: "Wyoming", ISOCode: "WY" }
		  ]
	  },
	  {
		  ISOCode: "AE", Name: "United Arab Emirates", States: [
			  { Name: "Abu Dhabi", ISOCode: "AZ" },
			  { Name: "Fujairah", ISOCode: "FU" },
			  { Name: "Sharjah", ISOCode: "SH" },
			  { Name: "Dubai", ISOCode: "DU" },
			  { Name: "Ras Al Khaimah", ISOCode: "RK" },
			  { Name: "Umm Al Quwain", ISOCode: "UQ" },
			  { Name: "Ajman", ISOCode: "AJ" }
		  ]
	  }
  ]

  //For user profile/user history tabs
  jQuery(document).ready(function ($) {
    // frontend tabbing control
    $('body').on('click', '.setting-tabs a', function (e) {
      e.preventDefault();
      if (!$(this).hasClass('active')) {
        $('.setting-tabs a').removeClass('active');
        $(this).addClass('active');

        var rel = $(this).attr('data-tab');
        $('.user-settings .panel-wrap .wrap').removeClass('active');
        $('.user-settings .panel-wrap .wrap#' + rel).addClass('active');
      }
    });
    $scope.EmailCollision = false
    $scope.AnonWinnerButtonMessage = 'SettingsAnonWinnerButtonMessageNeutral'
    $scope.UnsubButtonMessage = 'SettingsUserUnsubButtonMessageNeutral'
    $scope.UserButtonMessage = 'SettingsUpdateButtonMessageNeutral'
    $scope.UpdateButtonMessage = 'SettingsUpdateButtonMessageNeutral'
    $scope.PasswordButtonMessage = 'SettingsPasswordButtonMessageNeutral'
    $scope.EmailErrorMessage = 'SettingsProfileEmailError'

    $scope.Countries.find(function (item, i) {
      if (item.ISOCode === $scope.User.ContactCountry) {
        $scope.States = $scope.Countries[i].States
      }
    });
  });


  //Defaults update button text
  $scope.PasswordButtonDisabled = false;
  $scope.Password_Validation_Failed = false;
  $scope.UpdateButtonDisabled = false;
  $scope.UserButtonDisabled = false;
  $scope.UnsubButtonDisabled = false;
  $scope.Contact_Validation_Failed = false;
  $scope.User_Validation_Failed = false;

  //If email settings (and anonymous winner) have not been previously saved they appear as null.
  //This shows the user as subscribed to all emails (and a non-anonymous winner) if values are null.
  if ($scope.User.isUnsubscribedWinners == null) {
    $scope.User.isUnsubscribedWinners = false
    $scope.User.isUnsubscribedDontForget = false
    $scope.User.isUnsubscribedOrder = false
    
  }
  if ($scope.User.DisplayWinnerName == null) {
     $scope.User.DisplayWinnerName = true
  }

  //User Stats
  $http.get(TFL_Base_Url + "member/userHistory?MemberId=" + $scope.User.Id).then(function (data) {
    $scope.UserHistory = data.data
  });
  //User Win History
  $http.get(TFL_Base_Url + "member/userWinHistory?MemberId=" + $scope.User.Id).then(function (data) {
    $scope.UserWinHistory = data.data

    //If there is a win history, variable is set to true and table is shown
    if ($scope.UserWinHistory.length != 0) {
      $scope.isWinHistory = true
    }
  });

  //Determines if profile picture is already robot
  if (($scope.User.ImageUrl).includes("robot")) {
      $scope.isRobot = true;
  }

  $scope.Order_APIKey = Cookies.get('TLF_Auth_Token');

  $scope.PasswordBlock = { Current: '', New: '', Confirm: '' };

  $scope.getClass = function () {
    if (User.AuthenticationMethod == 'Email') {
      return "col wide"
    } else {
      return "col left"
    }
  }

  $scope.SaveContactInfo = function () {
    $scope.UpdateButtonDisabled = true;
    $scope.EmailCollision = false;
    $scope.UpdateButtonMessage = 'SettingsUpdateButtonMessageUpdating'

    if ($scope.User.ContactFirstName == '' ||
      $scope.User.ContactLastName == '' ||
      $scope.User.ContactAddress == '' ||
      $scope.User.ContactPostalZip == '' ||
      $scope.User.ContactCity == '' ||
      $scope.User.ContactProvinceState == '' ||
      $scope.User.ContactCountry == '' ||
      $scope.User.ContactFirstName == null ||
      $scope.User.ContactLastName == null ||
      $scope.User.ContactAddress == null ||
      $scope.User.ContactPostalZip == null ||
      $scope.User.ContactCity == null ||
      $scope.User.ContactProvinceState == null ||
      $scope.User.ContactCountry == null) {
      $scope.Contact_Validation_Failed = true;
      $scope.UpdateButtonDisabled = false;
      $scope.UpdateButtonMessage = 'SettingsUpdateButtonMessageFailed'
    } else {
      $scope.Contact_Validation_Failed = false;
      jQuery(document).ready(function ($) {
        ContactInfoSvc.put({ APIKey: Cookies.get('TLF_Auth_Token') }, {
          ContactFirstName: $scope.User.ContactFirstName,
          ContactLastName: $scope.User.ContactLastName,
          ContactAddress: $scope.User.ContactAddress,
          ContactPostalZip: $scope.User.ContactPostalZip,
          ContactCity: $scope.User.ContactCity,
          ContactProvinceState: $scope.User.ContactProvinceState,
          ContactCountry: $scope.User.ContactCountry,
          ContactPhone: $scope.User.ContactPhone
        }, function (data) {
          $scope.UpdateButtonMessage = 'SettingsUpdateButtonMessageSaved'
        });
      });
    }
  }

  $scope.SaveUserInfo = function () {
    $scope.UserButtonDisabled = true;
    $scope.EmailCollision = false
    $scope.UserButtonMessage = 'SettingsUpdateButtonMessageUpdating'

    if ($scope.User.FirstName == '' ||
      $scope.User.LastName == '' ||
      $scope.User.Email == '' ||
      $scope.User.FirstName == null ||
      $scope.User.LastName == null ||
      $scope.User.Email == null) {
      $scope.User_Validation_Failed = true;
      $scope.UserButtonDisabled = false;
      $scope.UserButtonMessage = 'SettingsUpdateButtonMessageFailed'
      $scope.EmailErrorMessage = 'SettingsProfileEmailError'
    }
    else {
      $scope.Contact_Validation_Failed = false;

      var picture = document.getElementById("profilePicture").checked;
      if(picture == true){
        $scope.User.ImageUrl = "https://platform.thelottofactory.com/resource/img/robot" + (Math.floor(Math.random() * Math.floor(5)) + 1) + ".gif";
      }
      MemberSvc.put({ ApiKey: Cookies.get('TLF_Auth_Token'), MemberId: $scope.User.Id }, $scope.User, function (data) {
        $scope.UserButtonDisabled = false;
        $scope.UserButtonMessage = 'SettingsUpdateButtonMessageSaved'
      }, function (response) {
        $scope.EmailCollision = true
        $scope.UserButtonDisabled = false;
        $scope.UserButtonMessage = 'SettingsUpdateButtonMessageFailed'
        $scope.EmailErrorMessage = 'SettingsProfileEmailCollision'
      });
    }
  }

    $scope.UpdatePassword = function () {
        $scope.PasswordButtonDisabled = true;
        $scope.PasswordButtonMessage = 'SettingsPasswordButtonMessageUpdating'

        ResetPasswordValidationSvc.post(
            JSON.stringify({
                ApiKey: Cookies.get('TLF_Auth_Token'),
                CurrentPassword: $scope.PasswordBlock.Current,
                NewPassword: $scope.PasswordBlock.New,
                ConfirmPassword: $scope.PasswordBlock.Confirm
            }), function (data) {
                $scope.Password_Validation_Failed = false;
                $scope.PasswordButtonDisabled = false;
                $scope.PasswordButtonMessage = 'SettingsPasswordButtonMessageSaved'
            }, function (response) {
                $scope.Password_Validation_Failed = true;
                $scope.PasswordButtonDisabled = false;
                $scope.PasswordButtonMessage = 'SettingsPasswordButtonMessageFailed'
            })
    }
  //Updates user unsubscribe settings
  $scope.UpdateEmailSubs = function () {
    //changes update button text to updating
    $scope.UnsubButtonDisabled = true;
    $scope.UnsubButtonMessage = 'SettingsUserUnsubButtonMessageUpdating'

    //Stores current checkbox values
    var WinnerEmail = document.getElementById("UnsubscribedWinners").checked;
    var ForgetEmail = document.getElementById("UnsubscribedDontForget").checked;
    var OrderEmail = document.getElementById("UnsubscribedOrder").checked;

    //Saves new email subscription values
    EmailSettingsSvc.put({ ApiKey: Cookies.get('TLF_Auth_Token'), MemberId: $scope.User.Id, WinnerEmail: WinnerEmail, ForgetEmail: ForgetEmail, OrderEmail: OrderEmail }, function (data) {

    })
    //Changes update button text to saved
    $scope.UnsubButtonMessage = 'SettingsUserUnsubButtonMessageSaved'
    $scope.UnsubButtonDisabled = false;
  }

  //Updates anonymous winner settings
  $scope.UpdateAnonWinner = function () {
    //changes update button text to updating
    $scope.AnonButtonDisabled = true;
    $scope.AnonWinnerButtonMessage = 'SettingsAnonWinnerButtonMessageUpdating'

    //Stores current checkbox values
    var AnonWinner = document.getElementById("AnonWinnerCheck").checked;

    //Saves new email subscription values
    AnonWinnerSettingsSvc.put({ ApiKey: Cookies.get('TLF_Auth_Token'), MemberId: $scope.User.Id, AnonWinner: AnonWinner}, function (data) {

    })
    //Changes update button text to saved
      $scope.AnonWinnerButtonMessage = 'SettingsAnonWinnerButtonMessageSaved'
      $scope.AnonButtonDisabled = false;
  }

  $scope.UpdateBillingStates = function () {
	$scope.Countries.find(function (item, i) {
		if (item.ISOCode === $scope.User.ContactCountry) {
			$scope.States = $scope.Countries[i].States
		}
	});
  }
}

export default {
  name: 'settingsController',
  fn: SettingsController
}